/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 minecraft_bee.glb --transform
Author: Marina Vildanova (https://sketchfab.com/kittenpuff)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/minecraft-bee-c9937e06e98c463c9a645b299b24cd2f
Title: Minecraft Bee 🐝
*/

import React, { useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export function MinecraftBee({ isHappy, ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(
    "/minecraft_bee-transformed.glb"
  );
  useAnimations(animations, group);

  // Add animation when bee is happy
  useFrame((state) => {
    if (isHappy && group.current) {
      // Make the bee fly in a circle and bob up and down
      const time = state.clock.getElapsedTime();
      group.current.position.x = Math.sin(time) * 2;
      group.current.position.z = Math.cos(time) * 2;
      group.current.position.y = Math.sin(time * 2) * 0.3 + props.position[1];

      // Rotate the bee to face the direction it's flying
      group.current.rotation.y = -time + Math.PI / 2;

      // Tilt the bee slightly based on vertical movement
      group.current.rotation.z = Math.sin(time * 2) * 0.1;
    }
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group
          name="Sketchfab_model"
          rotation={[-Math.PI / 2, 0, 0]}
          scale={0.16}
        >
          <group
            name="32bde958fb4643638f790cd30ef6d0f4fbx"
            rotation={[Math.PI / 2, 0, 0]}
          >
            <group name="Object_2">
              <group name="RootNode">
                <group
                  name="R_wing"
                  position={[0.09, 2.16, -0.72]}
                  rotation={[-0.08, 0, 0]}
                />
                <group
                  name="r"
                  position={[0.06, 2.79, -0.17]}
                  rotation={[-0.08, 0, 0]}
                >
                  <mesh
                    name="r_Bee_MAT_0"
                    geometry={nodes.r_Bee_MAT_0.geometry}
                    material={materials.Bee_MAT}
                  />
                </group>
                <group
                  name="L_wing"
                  position={[0.09, 2.16, 0.73]}
                  rotation={[0.08, 0, 0]}
                />
                <group
                  name="l"
                  position={[0.2, 2.83, 0.18]}
                  rotation={[0.08, 0, 0]}
                >
                  <mesh
                    name="l_Bee_MAT_0"
                    geometry={nodes.l_Bee_MAT_0.geometry}
                    material={materials.Bee_MAT}
                  />
                </group>
                <group
                  name="Bee"
                  position={[0.28, 1.61, 0.01]}
                  rotation={[0, 0, -0.17]}
                />
                <group
                  name="b"
                  position={[0.28, 2.45, 0]}
                  rotation={[0, 0, -0.17]}
                >
                  <mesh
                    name="b_Bee_MAT_0"
                    geometry={nodes.b_Bee_MAT_0.geometry}
                    material={materials.Bee_MAT}
                  />
                </group>
                <group name="Flower" position={[-0.2, 0.98, 0]}>
                  <mesh
                    name="Flower_Flower_MAT_0"
                    geometry={nodes.Flower_Flower_MAT_0.geometry}
                    material={materials.Flower_MAT}
                  />
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/minecraft_bee-transformed.glb");
